import { LitElement, html, css } from 'lit';
import { eplibMixin } from './eplib-mixin';
import Autocomplete from 'bootstrap5-autocomplete';
import EplibFormUtils from './eplib-form-utils.js';
import { BootstrapCSS } from '../resources/css/bootstrap.css';
import { EplibStyles } from '../resources/css/style.css.js';
import { EXIST_BASE } from './eplib-constants.js';

/**
 * Applies a filter to the annotations on the review page.
 */

export class EplibAnnotationFilterForm extends eplibMixin(LitElement) {

  _clearFilter(event, that) {
    event.preventDefault();
    const form = event.target.form;
    EplibFormUtils.clearForm(form);

    const url = new URL(window.location.href);
    sessionStorage.removeItem('creator');
    url.searchParams.delete('creator');
    sessionStorage.removeItem('modifier');
    url.searchParams.delete('modifier');
    sessionStorage.removeItem('status');
    url.searchParams.delete('status');
    window.history.pushState(null, '', url.toString());

    that.emitTo('eplib-load', {
        "params": {
            "start": 1,
            "direction": 'nav-next'
        }
    }, ['review']);

    return false;
  }

  _applyFilter(event, that) {
    event.preventDefault();

    const form = event.target.form;
    const formData = new FormData(form);
    const formValues = Object.fromEntries(formData.entries());

    const url = new URL(window.location.href);
    const creator =  encodeURIComponent(formValues.creator || '');
    sessionStorage.setItem('creator', formValues.creator);
    url.searchParams.set('creator', formValues.creator);
    const modifier =  encodeURIComponent(formValues.modifier || '');
    sessionStorage.setItem('modifier', formValues.modifier);
    url.searchParams.set('modifier', formValues.modifier);
    const status = encodeURIComponent(formValues.status || '');
    sessionStorage.setItem('status', formValues.status);
    url.searchParams.set('status', formValues.status);

    window.history.pushState(null, '', url.toString());

    that.emitTo('eplib-load', {
        "params": {
            "start": 1,
            "direction": 'nav-next'
        }
    }, ['review']);

    return false;
  }

  async firstUpdated() {

    const typeAheads = this.shadowRoot.querySelectorAll('.typeahead-meta');
    typeAheads.forEach(element => {
      const type = element.getAttribute('id');
      Autocomplete.getOrCreateInstance(element, {
        server: EXIST_BASE + '/modules/autocomplete.xql',
        queryParam: 'q',
        serverParams: {type: `${type}`},
        highlightTyped: true,
        suggestionsThreshold: 4,
        liveServer: true,
        showAllSuggestions: true
      });
    });

    // Fill in any existing form choices from session storage.
    const creator = sessionStorage.getItem('creator') || '';
    this.shadowRoot.querySelector('#creator').setAttribute('value', creator);
    const modifier = sessionStorage.getItem('modifier') || '';
    this.shadowRoot.querySelector('#modifier').setAttribute('value', modifier);
    const status = sessionStorage.getItem('status');
    let status_index = -1;
    switch (status) {
      case 'pending':
        status_index = 1;
        break;
      case 'accepted':
        status_index = 2;
        break;
      case 'rejected':
        status_index = 3;
        break;
    }
    this.shadowRoot.querySelector('#status').selectedIndex = status_index;
  }

  render() {
    return html`
      <div>
        <div class="well well-sm">
          <form id="annotation-form_filter" action="#" class="form-horizontal" @submit="${this._applyFilter}">
            <div class="form-group-md">
              <div class="form-group row">
                <div class="col-sm-5"></div>
                <div class="col-sm-3">
                  <label id="annotation_apply_filter_label" for="annotation_apply_filter" class="btn btn-default btn-sm">
                    <span class="material-icons md-16">filter_alt</span>
                    Filter
                  </label>
                  <input id="annotation_apply_filter"
                         type="submit"
                         aria-labelledby="annotation_apply_filter_label"
                         class="visually-hidden"
                         @click="${event => this._applyFilter(event, this)}"/>
                </div>
                <div class="col-sm-3">
                  <label id="annotation_filter_reset_label" for="annotation_filter_reset" class="btn btn-default btn-sm">
                    <span class="material-icons md-16">filter_alt_off</span>
                    Clear
                  </label>
                  <input id="annotation_filter_reset"
                         type="reset"
                         aria-labelledby="annotation_filter_reset_label"
                         class="visually-hidden"
                         @click="${event => this._clearFilter(event, this)}"/>
                </div>
              </div>

              <div class="form-group row">
                <label for="status" id="status-ariaLabel" class="control-label col-sm-4">Status</label>
                <div class="col-sm-8">
                  <select id="status"
                          name="status"
                          aria-labelledby="status-ariaLabel"
                          class="form-control"
                          @focus="${EplibFormUtils.addFormGroupFocus}"
                          @blur="${EplibFormUtils.removeFormGroupFocus}">
                    <option value=""/>
                    <option value="pending">Pending</option>
                    <option value="accepted">Accepted</option>
                    <option value="rejected">Rejected</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label for="creator" id="creator-ariaLabel" class="control-label col-sm-4">Creator</label>
                <div class="col-sm-8">
                  <input id="creator"
                         name="creator"
                         type="search"
                         aria-labelledby="creator-ariaLabel"
                         class="form-control typeahead-meta"
                         autocomplete="off"
                         @focus="${EplibFormUtils.addFormGroupFocus}"
                         @blur="${EplibFormUtils.removeFormGroupFocus}"/>
                </div>
              </div>
              <div class="form-group row">
                <label for="modifier" id="creator-ariaLabel" class="control-label col-sm-4">Modifier</label>
                <div class="col-sm-8">
                  <input id="modifier"
                         name="modifier"
                         type="search"
                         aria-labelledby="modifier-ariaLabel"
                         class="form-control
                         typeahead-meta" autocomplete="off"
                         @focus="${EplibFormUtils.addFormGroupFocus}"
                         @blur="${EplibFormUtils.removeFormGroupFocus}"/>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>`;
  }

  static get styles() {
    return [
    BootstrapCSS,
    EplibStyles,
    css`
      .well {
        background-color: #fff;
        padding: 19px;
        -webkit-box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
      }

      label.control-label {
        font-size: 14px;
        font-weight: 100;
        margin: 8px 0 0 0;
      }
    `];
  }

}

customElements.define('eplib-annotation-filter-form', EplibAnnotationFilterForm);